type PossibleOption = {
  name: string;
};

const getOptionLabel = <T extends Record<string, unknown>>(option: T | string | unknown): string =>
  (option as PossibleOption)?.name;

export default getOptionLabel;
